import React, { useState, useEffect } from "react";
import { Tree } from "primereact/tree";
import * as RB from "react-bootstrap";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";

function DesignationEmp({ empListByRole, selectedKeys, setSelectedKeys }) {
  useEffect(() => {
    if (empListByRole && empListByRole.length > 0) {
      setSelectedKeys((prevState) => {
        const updatedSelectedKeys = { ...prevState };

        empListByRole.forEach((role) => {
          let allChildrenSelected = true;
          let anyChildSelected = false;

          role.children.forEach((employee) => {
            if (prevState[employee.key]?.checked) {
              anyChildSelected = true;
            } else {
              allChildrenSelected = false;
              updatedSelectedKeys[employee.key] = { checked: false };
            }
          });

          if (allChildrenSelected) {
            updatedSelectedKeys[role.key] = {
              checked: true,
              partialChecked: false,
            };
          } else if (anyChildSelected) {
            updatedSelectedKeys[role.key] = {
              checked: false,
              partialChecked: true,
            };
          } else {
            delete updatedSelectedKeys[role.key];
          }
        });

        return updatedSelectedKeys;
      });
    }
  }, [empListByRole, selectedKeys]);

  const onSelectionChange = (e) => {
    setSelectedKeys(e.value);
  };

  return (
    <RB.Card className="mb-3">
      <RB.Card.Header>
        <strong>Employees List</strong>
      </RB.Card.Header>
      <RB.Card.Body>
        <>
          {empListByRole && empListByRole.length > 0 ? (
            <Tree
              value={empListByRole}
              selectionMode="checkbox"
              selectionKeys={selectedKeys}
              onSelectionChange={onSelectionChange}
              propagateSelectionUp={true}
              // propagateSelectionDown={false}
            />
          ) : (
            <p>No designations selected.</p>
          )}
        </>
      </RB.Card.Body>
    </RB.Card>
  );
}

export default DesignationEmp;
